<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file AccountSubscriber.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  AccountSubscriber.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<!------------------------------------------------------------------------------
 File: AccountSubscriber 
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 2019-03-27
 Time: 14:58
------------------------------------------------------------------------------->
<template>
    <div
            :id="modal_id"
            data-buy-now-modal
            class="modal show fade"
            ref="subscriber_modal"
            tabindex="-1"
            role="dialog"
    >
        <div class="modal-dialog modal-dialog-centered"
             role="document"
        >
            <div v-if="display === true" class="modal-content">
                <div class="modal-header"
                     :class="{
                    'bg-primary':!confirmed,
                    'bg-success':confirmed
                    }"
                >

                    <div class="w-100 d-flex justify-content-between align-items-center">
                        <h5>Big Parking Special Offers</h5>
                        <div class="cursor-pointer"
                             data-dismiss="modal"
                             aria-label="Close"
                        >
                            <div class="float-right border-0 cursor-pointer"
                                 v-on:click="close()">
                                <i class="icon-180-x-hover material-icons" aria-hidden="true">close</i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-body">

                    <div class="text-center">
                        <h4>Always be prepared</h4>

                        <h1>Subscribe to <br>
                            get promos!</h1>
                    </div>
                    <div></div>

                </div>
                <div class="modal-footer py-0">
                    <div v-if="!confirmed"
                    >
                        <div class="btn btn-flat"
                             v-on:click="userConfirmed"
                        >
                            <div class="mx-auto">Yes please</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
	import {uniqueId} from '../../../../../../app/Shared/Resources/Assets/js/helpers/classesAndIds';

	export default {
		name: "account-subscriber",
		components: {},
		props: {
			url_in: {
				type: String
			},
			url_out: {
				type: String
			},

			news: {
				type: Boolean,
				default: false
			},
			sms: {
				type: Boolean,
				default: false
			}
		},
		created() {
		},
		destroyed() {
		},
		mounted() {
			if (!this.news) {
				this.display = true;
				$('#' + this.modal_id).modal({
					show: true,
					backdrop: 'static',
					keyboard: false
				});
			}
		},
		data() {
			return {
				modal_id: uniqueId(),
				display: false,
				confirmed: false,
				inputs: {
					subscribe_news: 'subscribe_news',
					subscribe_mobile: 'subscribe_mobile',
				}
			}
		},
		methods: {
			close() {
				this.updateSubscription(false)
			},
			userConfirmed() {
				let self = this;
				self.updateSubscription(true);

				self.display = false;
				$('#' + self.modal_id)
					.modal('hide')
					.on('hidden.bs.modal', function (e) {
						$('#' + self.modal_id).modal('dispose')
					});
				toastr.success("Excellent! we'll send you any new promos as they come in");
			},
			updateSubscription(subscribed) {
				let data = {};
				axios.get((subscribed) ? this.url_in : this.url_out, data);
			},
		},
		watch: {},
		computed: {}
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/account/AccountSubscriber.vue